import { DocumentNode } from 'graphql';
import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import { IProductSchemaPartial } from '../../type/product';

export interface IUnpublishProductsMutationFields {
  _ids: string[];
}


export interface IUnpublishProductsMutationResponseFields {
  updatedProducts: IProductSchemaPartial[];
}



export function unpublishProductsMutation(fragment: string): DocumentNode {
  return gql`
        mutation unpublishProducts (
        $_ids: [String]!
        ) {
        unpublishProducts (
        _ids: $_ids
        ) {
        ...fragment
        }
        }
        fragment fragment on UnpublishProductsMutationResponse {
        code
        success
        message
        ${fragment}
        }
    `;
}

export function useUnpublishProductsMutation<TData extends Partial<IUnpublishProductsMutationResponseFields>>(
  fragment: string, options?: MutationHookOptions<{ unpublishProducts: TData },
        IUnpublishProductsMutationFields>,
) {
  return useMutation<{ unpublishProducts: TData },
      IUnpublishProductsMutationFields>(
        unpublishProductsMutation(fragment), options,
      );
}
